Vue.component("RefillGame", {
    props: {
        image: {
            type: Object,
            required: true
        }
    },
    template: `
        <div class="row">
            <div class="col-12 px-0">
                <!-- Banniere Jeu dans la page home.... sans non cliquable -->
                <picture>
                    <source media="(max-width: 320px)"
                            :srcset="image.xsImage.srcSet"/>
                    <source media="(min-width: 321px) and (max-width: 479px)"
                            :srcset="image.smallImage.srcSet"/>
                    <source media="(min-width: 480px) and (max-width: 767px)"
                            :srcset="image.mediumImage.srcSet"/>
                    <source media="(min-width: 768px) and (max-width: 1023px)"
                            :srcset="image.largeImage.srcSet"/>
                    <source media="(min-width: 1024px) and (max-width: 1279px)"
                            :srcset="image.xlImage.srcSet"/>
                    <source media="(min-width: 1280px)"
                            :srcset="image.xxlImage.srcSet"/>
                    <img class="img-fluid" alt="" :src="image.src"/>
                </picture>
            </div>
        </div>
`
});
